import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "src/components/common/ProtectedTenantRoute";
import LoginPage from "./LoginPage";
import { appRoutes } from "./routes.config";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {appRoutes.map((r, idx) => (
        <Route
          key={idx}
          path={r.path}
          element={<ProtectedRoute>{r.element}</ProtectedRoute>}
        />
      ))}

      {/* Fallback redirect */}
      <Route path="/*" element={<Navigate to="/app/dashboard" replace />} />
    </Routes>
  );
};

export default AppRoutes;
